// generated by genversion
export var version = '4.0.0';
//# sourceMappingURL=version.js.map